import React from "react";

const Loading = () => {
  return (
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div className="text-center">
        <div className="custom-loader"></div>
      </div>
    </div>
  );
};

export default Loading;
